import React from 'react';
import tradycyjna_specjalnosc from '../images/1-tradycyjna-spec.png';
import produkt_polski from '../images/2-produkt-polski.png';
import rasa1 from '../images/rasa1.png';
import rasa2 from '../images/rasa2.png';
import dziedzitwo_kulinarne from '../images/3-dziedzitwo-kulinarne.png';

const RegionalProducts = () => {
  return (
    <section className="regional-section">
      <div className="regional-container container">
        <h2 className="mb-4">Produkty regionalne</h2>
        <p className="mb-4">
          Nasz zakład mięsny może się szczycić niezwykłymi osiągnięciami, które
          stanowią nie tylko fundament naszej pracy, ale również przynoszą
          korzyści naszym klientom.
        </p>
        <div className="grid grid-cols-2 sm:grid-cols-4 justify-center">
          <img
            src={tradycyjna_specjalnosc}
            alt="tradycyjna specjalność"
            className="mx-auto w-[7rem] sm:w-[9rem]"
          />
          <img
            src={produkt_polski}
            alt="produkt polski"
            className="mx-auto w-[7rem] sm:w-[9rem]"
          />
          <img
            src={rasa1}
            alt="rasa rodzima"
            className="mx-auto w-[7rem] sm:w-[9rem]"
          />
          <img
            src={rasa2}
            alt="rasa rodzima"
            className="mx-auto w-[7rem] sm:w-[9rem]"
          />
        </div>
      </div>
    </section>
  );
};

export default RegionalProducts;
